export const TableHelpers = {
    data() {
        return {
            tableColumns: [
                {
                    title: 'CI/RUC',
                    type: 'text',
                    key: 'taxid',
                },
                {
                    title: 'Nombre(s)',
                    type: 'text',
                    key: 'first_name',
                },
                {
                    title: 'Apellido(s)',
                    type: 'text',
                    key: 'last_name',
                },
                /* {
                    title: 'Funcion',
                    type: 'custom-html',
                    key: 'evaluator_type',
                    modifier: (item) => {
                        return item.value;
                    }
                }, */
                {
                    title: 'Ambito',
                    type: 'custom-html',
                    key: 'scope',
                    modifier: (item) => {
                        let tmp = {
                            O: "SAE",
                            E: "Externo",
                        }
                        return tmp[item];
                    }
                },
                {
                    title: 'Tipo de Institucion',
                    type: 'custom-html',
                    key: 'type_institution',
                    modifier: (item) => {
                        let tmp = {
                            PU: "Publica",
                            PR: "Privada",
                        }
                        return tmp[item];
                    }
                },
                {
                    title: 'Institucion',
                    type: 'custom-html',
                    key: 'institution',
                    modifier: (item) => {

                        return item;
                    }
                },
                {
                    title: 'Estado',
                    type: 'custom-html',
                    key: 'is_active',
                    isVisible: true,
                    modifier: (item) => {
                        let className = 'success';
                        let status = 'Activo';
                        if (item == 0) {
                            className = 'danger';
                            status = 'Inactivo';
                        }
                        return `<span class="badge badge-sm badge-pill badge-${className}">${status}</span>`;
                    }
                },
            ],
            actionObj: {
                title: 'Acciones',
                type: 'action',
            }
        }
    },
}